// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeExam = {
  examAuthInvalidRefreshToken: "Your sign-in session is no longer valid. Sign in again",
  examAuthAccountLocked: "The account is locked. Try again later",
  examAuthCredentialsInvalid: "The username or password is incorrect",
  examAuthCaptchaRequired: "Complete the captcha before signing in",
  examAuthCaptchaInvalid: "The captcha is incorrect",
  examAuthIpNotAllowed: "The current IP {ip} is not allowed to sign in",
  examAuthPasswordReuseDisallowed: "The new password must be different from the current password",
  examAuthCurrentPasswordIncorrect: "The current password is incorrect",
  examAuthPermissionDenied: "Your account does not have permission to perform this action",
  examScoringAttemptNotFound: "Attempt #{attempt_id} was not found",
  examExamNotFound: "Exam #{exam_id} was not found",
  examExamCodeNotFound: "Exam {exam_code} was not found",
  examExamCodeRequired: "An exam code is required",
  examEntryRequired: "An exam entry code or subdomain is required",
  examEntryNotFound: "The exam entry was not found",
  examEntryCodeConflict: "The exam entry code is already in use",
  examEntrySubdomainConflict: "The exam entry subdomain is already in use",
  examExamFieldInvalid: "Exam field {field} is invalid",
  examExamStatusUpdateForbidden:
    "Use a status action to change exam status from {current_status} to {requested_status}",
  examExamArchivedEditForbidden: "Exam #{exam_id} is archived and cannot be edited",
  examExamPaperVersionChangeForbidden:
    "Exam #{exam_id} has attempts and its paper version cannot be changed",
  examExamCandidateAssignmentForbidden: "Candidates cannot be assigned to this exam",
  examExamUnsupportedStatusAction: "This exam status action is not supported",
  examExamStatusTransitionInvalid:
    "Exam #{exam_id} cannot perform {action} while its status is {current_status}",
  examExamAssignedCandidatesRequired:
    "Assign candidates to exam #{exam_id} before performing {action}",
  examExamDurationRequired: "Exam #{exam_id} requires a duration greater than zero",
  examExamRunningAttemptsExist: "Exam #{exam_id} has attempts in progress and cannot be archived",
  examExamRequiresEndedStatus: "Exam #{exam_id} must end before scores can be published",
  examExamDeleteRequiresDraft: "Exam #{exam_id} can only be deleted while it is a draft",
  examExamHasAttemptRecords: "Exam #{exam_id} has attempt records and cannot be deleted",
  examCandidateUserNotFound: "Candidate user #{candidate_id} was not found",
  examCandidateUserInvalid: "Candidate user #{candidate_id} is invalid: {reason}",
  examCandidateNotAssigned: "Candidate #{candidate_id} is not assigned to exam #{exam_id}",
  examCandidateHasAttempt: "Candidate #{candidate_id} already has attempt data for exam #{exam_id}",
  examStaffUserNotFound: "Staff user #{staff_user_id} was not found",
  examStaffUserInvalid: "Staff user #{staff_user_id} is invalid: {reason}",
  examStaffAssignmentNotFound: "Staff user #{staff_user_id} has no assignment for exam #{exam_id}",
  examRuntimeDataContractInvalid: "Exam runtime data contract is invalid",
  examRuntimeExportDependencyMissing: "An exam runtime export dependency is unavailable",
  examExamForbidden: "You do not have access to exam #{exam_id}",
  examAttemptNotFound: "Attempt #{attempt_id} was not found",
  examAttemptForbidden: "You do not have access to attempt #{attempt_id}",
  examAttemptQuestionNotFound: "Attempt question #{attempt_question_id} was not found",
  examUserValidationFailed: "User data is invalid",
  examUserDataContractInvalid: "User data contract is invalid",
  examCandidateImportValidationFailed: "Candidate import data is invalid",
  examCandidateImportDependencyUnavailable:
    "A candidate import or template export dependency is unavailable",
  examCandidateImportTemplateGenerationFailed:
    "The candidate import template could not be generated",
  examQuestionNotFound: "Question #{question_id} was not found",
  examQuestionCodeNotFound: "Question {question_code} was not found",
  examQuestionVersionNotFound: "Question version for #{question_id} was not found",
  examQuestionValidationFailed: "Question data is invalid",
  examQuestionStateConflict:
    "Question #{question_id} cannot perform {action} while its status is {current_status}",
  examQuestionInUse:
    "Question #{question_id} is referenced by {reference_type} and cannot be deleted",
  examCustomFieldValidationFailed: "Custom field data is invalid",
  examCustomFieldNotFound: "The custom field definition or related resource was not found",
  examEnvironmentPracticalSessionQuestionTypeNotSupported:
    "Question #{question_id} with type {question_type} does not support an experience session",
  examEnvironmentPracticalSessionContainerIdRequired: "A container ID is required",
  examEnvironmentFlagValidationQuestionTypeNotSupported:
    "Question #{question_id} with type {question_type} does not support flag validation",
  examEnvironmentFlagValidationActiveInstanceRequired:
    "Question #{attempt_question_id} has no active environment instance",
  examEnvironmentFlagValidationInstanceDestroyed:
    "Environment instance #{instance_id} was destroyed and cannot validate a flag",
  examEnvironmentCallbackInstanceDestroyed:
    "Environment instance #{instance_id} was destroyed and cannot accept callbacks",
  examEnvironmentCallbackTokenMismatch: "The environment callback token is invalid",
  examEnvironmentCallbackTokenRequired: "An environment callback token is required",
  examEnvironmentInstanceQuestionTypeNotSupported:
    "Question #{question_id} with type {question_type} does not support environment execution",
  examEnvironmentInstanceCreationLimitExceeded:
    "Question #{attempt_question_id} reached its environment creation limit of {max_create_count}",
  examEnvironmentInstanceImageRequired:
    "An image is required for a {question_type} environment instance",
  examEnvironmentInstanceContainerPortInvalid:
    "The container port is invalid for a {question_type} environment instance",
  examEnvironmentInstanceInitScriptUnsupported:
    "Initialization scripts are not supported for a {question_type} container-blackbox environment",
  examEnvironmentInstanceDataContractInvalid:
    "The persisted environment-instance data contract is invalid (field: {field})",
  examEnvironmentNodeRuntimeRequestFailed: "The node-runtime request failed",
  examEnvironmentNodeRuntimeUnavailable: "The node runtime is unavailable",
  examEnvironmentNodeRuntimeDataContractInvalid:
    "The node runtime returned an invalid data contract (operation: {operation}, field: {field})",
  examEnvironmentExecutionFabricConfigurationMissing:
    "Execution Fabric configuration is missing (field: {field})",
  examEnvironmentCandidateConcurrentLimitExceeded:
    "The active environment count {active_count} reached the limit of {max_active_count}",
  examEnvironmentCandidateTotalCreationLimitExceeded:
    "The total environment creation count {total_count} reached the limit of {max_total_count}",
  examEnvironmentEvaluationInstanceDestroyed:
    "Environment instance #{instance_id} was destroyed and cannot be evaluated",
  examEnvironmentEvaluationSelfCheckDisabled:
    "Self-check is disabled for attempt question #{attempt_question_id} in the current exam",
  examEnvironmentEvaluationSelfCheckLimitExceeded:
    "Self-check limit {max_self_check_count} reached for attempt question #{attempt_question_id} ({used_self_check_count} used)",
  examEnvironmentEvaluationDataContractInvalid:
    "Environment instance #{instance_id} has an invalid evaluation data contract (field: {field})",
  examEnvironmentEvaluationLocalWorkspaceUnavailable:
    "The local workspace for environment instance #{instance_id} is unavailable; rebuild the environment before retrying",
  examEnvironmentDockerInstanceImageRequired: "A Docker instance image name is required",
  examEnvironmentDockerInstanceContainerIdRequired: "A Docker instance ID is required",
  examEnvironmentDockerInstanceDataContractInvalid:
    "Docker instance service returned an invalid payload",
  examEnvironmentTaskCenterExecutionCenterRequired:
    "This task-center operation requires execution center mode",
  examEnvironmentTaskCenterHandoffFailed: "The task-center request failed. Try again later",
  examEnvironmentTaskCenterDataContractInvalid: "The task center returned an invalid payload",
  examEnvironmentOrchestratorHandoffFailed:
    "The environment-instance destroy request could not be submitted to the orchestrator",
  examEnvironmentDockerImageImageRequired: "An image name is required",
  examEnvironmentDockerImageNotFound: "Image was not found: {image}",
  examEnvironmentDockerImageDataContractInvalid: "Docker image service returned an invalid payload",
  examEnvironmentDockerImageExecutionCenterRequired:
    "This Docker image operation requires execution center mode",
  examEnvironmentDockerImageDefaultPortInvalid: "The default port is invalid",
  examEnvironmentDockerImageDefaultPortNotDeclared:
    "The default port is not declared by the selected image",
  examEnvironmentDockerImageArchiveNotFound: "The Docker image archive was not found",
  examEnvironmentDockerImageArchiveInvalid: "The Docker image archive must be a valid tar file",
  examEnvironmentDockerImageArchiveTooLarge:
    "The Docker image archive exceeds the {max_bytes}-byte limit",
  examEnvironmentDockerImageAssetImportFailed:
    "Importing the Docker image from the asset center failed",
  examEnvironmentDockerImageDockerfileRequired: "Dockerfile content is required",
  examEnvironmentDockerImageDockerfileTooLarge: "The Dockerfile exceeds the {max_bytes}-byte limit",
  examEnvironmentDockerImageBuildTimeout: "Docker image build timed out",
  examEnvironmentDockerImageRuntimeUnavailable: "The Docker runtime is unavailable",
  examEnvironmentDockerImageBuildFailed: "Docker image build failed",
  examJudgeDataContractInvalid: "Judge data is malformed: {field}",
  examJudgeQuestionTypeNotSupported:
    "Question #{question_id} with type {question_type} is not supported for {operation}",
  examJudgeSourceCodeNotFound:
    "Source code for attempt question #{attempt_question_id} was not found",
  examJudgeRuntimeUnavailable: "Judge runtime for {language} is unavailable",
  examJudgeUnsupportedLanguage: "Judge does not support language {language}",
  examJudgeSubmissionNotFound:
    "Judge submission for attempt question #{attempt_question_id} was not found",
  examJudgeServiceRequestFailed: "Judge service request failed",
  examJudgeServiceUnavailable: "Judge service is unavailable",
  examJudgeServiceInvalidResponse: "Judge service returned an invalid response",
  examReviewObjectiveQuestionNotReviewable:
    "Objective question #{question_id} cannot be manually reviewed",
  examPlatformApplicationNotFound: "Application {app_key} was not found",
  examEnvironmentInstanceNotFound: "Environment instance #{instance_id} was not found",
  examScoringScoresUnavailable: "Scores for attempt #{attempt_id} are not available yet",
} as const;
